import { Component, input } from '@angular/core';
import { BIKRate } from 'src/app/models/vehicle-order-driver-bik-preference.model';
import { VehicleOrderUI } from 'src/app/models/vehicle-order-response.model';
import { FuelType } from 'src/app/helpers/enum/fuel-type.enum';

@Component({
    selector: 'app-vehicle-spec-grid',
    templateUrl: './vehicle-spec-grid.component.html',
    styleUrls: ['./vehicle-spec-grid.component.scss'],
    standalone: false
})
export class VehicleSpecGridComponent {
    vehicle = input.required<VehicleOrderUI>();
    selectedBIK = input.required<BIKRate>();
    readonly FuelType = FuelType;
}
